import { sentenceCase } from './format';

/**
 * One colour per status meaning, everywhere (timesheets, time off, swaps, shifts, expenses):
 * waiting on someone = orange, submitted/open = sky, done/approved = emerald, rejected/failed = rose,
 * queried = violet, draft/cancelled/withdrawn = slate. Labels are sentence case ("Approved", "Awaiting manager").
 */
export const STATUS_TONE: Record<string, string> = {
  pending: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
  submitted: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  approved: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  rejected: 'bg-rose-100 text-rose-800 dark:bg-rose-900/40 dark:text-rose-200',
  queried: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
  draft: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  ended: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
};
const STATUS_GROUP: Record<string, keyof typeof STATUS_TONE> = {
  pending: 'pending', pending_peer: 'pending', pending_manager: 'pending', awaiting: 'pending', requested: 'pending', unconfirmed: 'pending',
  submitted: 'submitted', open: 'submitted', in_progress: 'submitted', offered: 'submitted',
  approved: 'approved', published: 'approved', accepted: 'approved', confirmed: 'approved', completed: 'approved', paid: 'approved', resolved: 'approved', done: 'approved',
  rejected: 'rejected', declined: 'rejected', failed: 'rejected', missed: 'rejected', overdue: 'rejected',
  queried: 'queried', query: 'queried',
  draft: 'draft', cancelled: 'ended', withdrawn: 'ended', expired: 'ended', closed: 'ended', archived: 'ended',
};
const STATUS_LABEL: Record<string, string> = { pending_peer: 'Awaiting colleague', pending_manager: 'Awaiting manager', in_progress: 'In progress' };
export const statusLabel = (status: string) => STATUS_LABEL[status] ?? sentenceCase(status);
export const statusTone = (status: string) => STATUS_TONE[STATUS_GROUP[status] ?? ''] ?? 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200';
